import {
	CustomFieldType,
	ICustomFieldViewModel,
	TextFieldValidation,
} from '../../LoggedInWeb/loggedinweb-generated';

export type CustomFieldViewModel = ICustomFieldViewModel;

const regexValidationLettersOnly = '^\\D*$';
const regexValidationNumbersOnly = '^[0-9]*$';

type ValidationRules = { [rule: string]: any };

export type PropertyMetadata = {
	propertyName: string;
	displayName?: string;
	placeholder?: string;
	translationParams?: { [key: string]: any }; 
	validationRules?: { [rule: string]: any };
};

export function getCustomFieldPropertyMetadata(field: CustomFieldViewModel): PropertyMetadata {
	return {
		propertyName: field.Key,
		displayName: field.Label,
		placeholder: field.Type === CustomFieldType.Number || field.Type === CustomFieldType.Text ? field.Placeholder : '',
		translationParams: setTranslationParams(field),
		validationRules: getValidationRules(field),
	};
}

export function getValidationRules(field: CustomFieldViewModel): ValidationRules {
	const rules: ValidationRules = {};

	switch (field.Type) {
		case CustomFieldType.Text:
			setLengthRule(rules, field.MinLength, field.MaxLength, field.Label);

			if (field.IsRequired) {
				rules['required'] = {
					errorMessage: `Please enter {{field}}`,
				};
			}

			if (field.Validation === TextFieldValidation.LettersOnly) {
				rules['regex'] = {
					errorMessage: `The {{field}} is not valid`,
					parameters: {
						pattern: regexValidationLettersOnly,
					},
				};
			}
			break;
		case CustomFieldType.Number:
			setLengthRule(rules, field.MinLength, field.MaxLength, field.Label);

			if (field.IsRequired) {
				rules['required'] = {
					errorMessage: `Please enter {{field}}`,
				};
			}

			rules['regex'] = {
				errorMessage: `The {{field}} is not valid`,
				parameters: {
					pattern: regexValidationNumbersOnly,
				},
			};
			break;
		case CustomFieldType.DropDown:
		case CustomFieldType.Fund:
			if (field.IsRequired) {
				rules['required'] = {
					errorMessage: `Please choose an option for {{field}}`,
				};
			}

			break;
	}

	return rules;
}

function setLengthRule(rules: ValidationRules, minLength: number, maxLength: number, fieldLabel: string) {
	let message = `Please enter between {{minLength}} and {{maxLength}} characters for {{field}}`;
	if (minLength === maxLength) {
		message = `Please enter {{minLength}} characters for {{field}}`;
	}

	rules['length'] = {
		errorMessage: message,
		parameters: {
			min: minLength,
			max: maxLength,
		},
	};
}

function setTranslationParams(field: CustomFieldViewModel) {
	switch (field.Type) {
		case CustomFieldType.Number:
			return {
				field: `${field.Label.toLowerCase()}`,
				minLength: field.MinLength,
				maxLength: field.MaxLength,
			}
		case CustomFieldType.Text:
		case CustomFieldType.DropDown:
		case CustomFieldType.Fund:
			return {
				field: `${field.Label.toLowerCase()}`
			}
	}
}
